export default __webpack_public_path__ + "static/media/connected.5fcbf6e7.svg";